export const tokens = {
    suffixAction: {
        tiny: 26,
        small: 28,
        medium: 32,
        large: 36,
        huge: 44,
    },
    suffixIcon: {
        tiny: 12,
        small: 14,
        medium: 18,
        large: 22,
        huge: 26,
    },
};
